import ClipboardJS from "clipboard";
import { HSTooltip } from "preline/preline";
import { addToast } from "../toasts";

export function initClipboardHelper() {
  const $clipboards = document.querySelectorAll(".js-clipboard");
  $clipboards.forEach((el) => {
    const clipboard = new ClipboardJS(el, {
      text: (trigger: HTMLElement) => {
        const clipboardText = trigger.dataset.clipboardText;

        if (clipboardText) return clipboardText;

        const clipboardTarget = trigger.dataset.clipboardTarget;
        const $element = document.querySelector(clipboardTarget!) as
          | HTMLSelectElement
          | HTMLInputElement
          | HTMLTextAreaElement;

        if (
          $element.tagName === "SELECT" ||
          $element.tagName === "INPUT" ||
          $element.tagName === "TEXTAREA"
        )
          return $element.value;
        else return $element.textContent ?? "";
      },
    });

    clipboard.on("success", (e) => {
      const tmpEL = el as HTMLElement;
      const openInNewTab = tmpEL.getAttribute('open-in-new-tab');
      if (openInNewTab === 'true') {
        const copiedText = e.text;
        if (copiedText && (copiedText.startsWith('http://') || copiedText.startsWith('https://'))) {
          window.open(copiedText, '_blank');
        }
        return;
      }

      const dataToast = tmpEL.getAttribute('data-toast');
      if (dataToast) {
        addToast({ toastBody: dataToast }, "default", "success");
        return;
      }

      const $default = tmpEL.querySelector(
        ".js-clipboard-default"
      ) as HTMLElement;
      const $success = tmpEL.querySelector(
        ".js-clipboard-success"
      ) as HTMLElement;
      const $successText = tmpEL.querySelector(".js-clipboard-success-text") as HTMLElement;
      const successText = tmpEL.dataset.clipboardSuccessText || "";
      const tooltip = tmpEL.closest(".hs-tooltip") as HTMLElement;

      if ($successText && !$successText.dataset.oldText) {
        $successText.dataset.oldText = $successText.textContent || "Copy";
      }

      if ($successText) {
        $successText.textContent = successText;
      }
      if ($default && $success) {
        $default.style.display = "none";
        $success.style.display = "flex";
      }
      if (tooltip) HSTooltip.show(tooltip);

      setTimeout(function () {
        if ($successText && $successText?.dataset.oldText)
          $successText.textContent = $successText?.dataset.oldText;
        if (tooltip) HSTooltip.hide(tooltip);
        if ($default && $success) {
          $success.style.display = "";
          $default.style.display = "";
        }
      }, 800);
    });
  });
}
